import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import Swal from "sweetalert2";
import { Subject } from "rxjs";
import { PedidoService } from "@core/services/pedido.service";
import { PedidoInterface } from "app/module/pedido-interface";
import moment from "moment";

@Component({
    selector: 'app-listar-rastreei',
    templateUrl: './listar-rastreei.component.html',
    styleUrls: ['./listar-rastreei.component.scss']
})
export class ListarRastreeiComponent implements OnInit {
    constructor(private pedidoService: PedidoService) {
        this._unsubscribeAll = new Subject();
    }

    private _unsubscribeAll: Subject<any>;
    private tempData = [];

    contentHeader: object;
    basicSelectedOption: number = 10;
    ColumnMode = ColumnMode;
    rows: Array<PedidoInterface> | any = [];
    temp: Array<PedidoInterface> | any = [];
    selectedStatus: any;
    dateOptions = {
        altInput: true,
        mode: 'single',
        altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
        defaultDate: moment(new Date).format('YYYY-MM-DD'),
        altFormat: "d/m/Y",
    };
    starting: boolean = false;


    @ViewChild(DatatableComponent) table: DatatableComponent;
    @ViewChild("tableRowDetails") tableRowDetails: any;
    ngOnInit(): void {
        this.starting = true;
        this.contentHeader = {
            headerTitle: "Pedidos Rastreei",
            actionButton: false,
            breadcrumb: {
                type: "",
                links: [
                    {
                        name: "Início",
                        isLink: false,
                    },
                    {
                        name: "Pedido",
                        isLink: false,
                    },
                ],
            },
        };

        this.pedidoService.getPedidoEmpresa(2).subscribe(
            (res) => {
                (this.rows = res), (this.temp = res), (this.tempData = this.rows.data);
                this.starting = false;
            },
            (error) => {
                console.log(error);
                this.starting = false;
            }
        );
    }

    ngAfterContentChecked() {
        this.rows = [...this.rows];
    }

    numPedidoFilter(event) {
        const val = event.target.value.toLowerCase();

        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.num_pedido.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
    }

    nomeFantasiaFilter(event) {
        const val = event.target.value.toLowerCase();

        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.nome_fantasia.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
    }

    statusFilter() {
        if (this.selectedStatus == 0) {
            this.rows = this.temp;
            return false
        }
        const val = this.selectedStatus

        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.id_status.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
    }

    cpfFilter(event) {
        const val = event.target.value.toLowerCase();

        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.cpf_cnpj.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
    }

    dateFilter(event) {
        const val = event.target.value.toLowerCase();
        const [day, month, year] = val.split("/");
        const result = [year, month, day].join("-");
        if (val.length < 10) {
            this.rows = this.temp;
        }
        if (val.length == 10) {
            // filter our data
            const temp = this.temp.filter(function (d) {
                return d.dt_pedido.substring(0, 10).toLowerCase().indexOf(result) !== -1 || !result;
            });
            // update the rows
            this.rows = temp;
            // Whenever the filter changes, always go back to the first page
            this.table.offset = 0;
        }
    }

    updateFilter(event) {
        const val = event.target.value.toLowerCase();

        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.campanha.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
        // Whenever the filter changes, always go back to the first page
        this.table.offset = 0;
    }

    confirmDeleteAlert(data) {
        Swal.fire({
            title: "Confirmação",
            text: "Deseja excluir o item?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Excluir",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn btn-danger",
                cancelButton: "btn btn-primary ml-1",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // return this.pedidoService.delete(1, data).subscribe(
                // 	(res) => {
                // 		Swal.fire({
                // 			title: "Sucesso!",
                // 			text: "O item foi excluído.",
                // 			icon: "success",
                // 			confirmButtonText: "Confirmar",
                // 		}).then((result) => {
                // 			if (result.isConfirmed) {
                // 				this.pedidoService.get().subscribe(
                // 					(res) => (this.rows = res),
                // 					(error) => error
                // 				);
                // 			}
                // 		});
                // 	},
                // 	(error) => {
                // 		Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
                // 	}
                // );
            }
        });
    }
}
